import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../dynamic-form/odin-controller.component';
import type { ToggleButtonProps } from './toggle-button';
import ToggleButton from './toggle-button';

export interface HfToggleButtonProps<TFieldValues extends FieldValues = FieldValues> extends ToggleButtonProps {
  control: Control<TFieldValues>;
}

function HfToggleButton<TFieldValues extends FieldValues = FieldValues>(props: HfToggleButtonProps<TFieldValues>) {
  const { control, name, onChange, checked, id } = props;

  return (
    <OdinController
      control={control}
      name={name ?? 'toggle-button'}
      onChange={onChange}
      defaultValue={checked}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return <ToggleButton {...props} id={id} onChange={onChange} checked={!!value} error={error?.message} />;
      }}
    ></OdinController>
  );
}

export default HfToggleButton;
